import React from 'react';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';
import { toSvgColor } from 'apps/sigma2-ui/src/components/svg/types';

export const IconCheckboxUncheckedGroup: React.FC<SvgProps> = (props) => {
  const strokeColor = toSvgColor('currentColor', props);

  return (
    <g fill="none" {...(props.group ?? {})}>
      <path
        d="M1 14.25V3.75C1 2.64543 1.89543 1.75 3 1.75H13.5C14.6046 1.75 15.5 2.64543 15.5 3.75V14.25C15.5 15.3546 14.6046 16.25 13.5 16.25H3C1.89543 16.25 1 15.3546 1 14.25Z"
        stroke={strokeColor}
        strokeWidth="1.65"
      />
    </g>
  );
};

export const IconCheckboxUncheckedSvg: React.FC<SvgProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="18"
      viewBox="0 0 17 18"
      fill="none"
      {...(props.svg ?? {})}
    >
      <IconCheckboxUncheckedGroup {...props} />
    </svg>
  );
};
